import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Admin from "../store/ducks/admin.duck";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import { Grid, TableContainer, Tooltip, Table, TableHead, TableBody, TableRow, TableCell, makeStyles } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import IconButton from "@material-ui/core/IconButton";
import "../../_metronic/_assets/css/app2.css";

export default function ClientScore(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchClientScores({ clientID: props.clientID }));
  }, [dispatch, props.clientID]);

  const clientScores = useSelector((state) => state.admin.ClientScores || []);
  const clientScoreFile = useSelector((state) => state.admin.ClientScoreFile);
  const role = useSelector((state) => state.auth.roleDesc);
  // New Score Fields
  const [newScoreType, setNewScoreType] = useState("K10");
  const [newScore, setNewScore] = useState("0");
  const [newScoreDate, setNewScoreDate] = useState(new Date());
  const [newScoreStage, setNewScoreStage] = useState("Initial Assessment");
  const [newAssessmentFile, setNewAssessmentFile] = useState();
  const [fileInputKey, setFileInputKey] = useState(0);
  const [newScoreHelpText, setNewScoreHelpText] = useState("");
  // Delete Score Fields
  const [deleteScoreType, setDeleteScoreType] = useState("K10");
  const [deleteScore, setDeleteScore] = useState("0");
  const [deleteScoreDate, setDeleteScoreDate] = useState(new Date());
  const [deleteScoreId, setDeleteScoreId] = useState();
  const [deleteScoreStage, setDeleteScoreStage] = useState("Initial Assessment");
  const [showConfirmation, setShowConfirmation] = useState(false);
  // Update Score Fields
  const [updateScoreType, setUpdateScoreType] = useState("K10");
  const [updateScore, setUpdateScore] = useState("0");
  const [updateScoreDate, setUpdateScoreDate] = useState(new Date());
  const [updateScoreId, setUpdateScoreId] = useState();
  const [updateScoreStage, setUpdateScoreStage] = useState("Initial Assessment");
  const [showEditModal, setShowEditModal] = useState(false);
  const [updateScoreHelpText, setUpdateScoreHelpText] = useState("");

  const SCORE_RANGES = {
    K10: { min: 10, max: 50 },
    K5: { min: 5, max: 25 },
    IAR: { min: 0, max: 100 }, // <-- update to correct range
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 200,
      // maxWidth: 200,
    },
    media: {
      height: 200,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  }));

  const classes = useStyles();

  const clearScore = () => {
    setNewScoreType("K10");
    setNewScore("0");
    setNewScoreHelpText("");
    setNewScoreDate(new Date());
    setNewScoreStage("Initial Assessment");
    setNewAssessmentFile();
    setFileInputKey((prev) => prev + 1);
  };

  function handleFileFieldChange(propertyName, event) {
    // console.log(event.currentTarget.files[0]);
    setNewAssessmentFile(event.currentTarget.files[0]);
  }

  function DeleteScoreDisplay(props) {
    return (
      <Tooltip title="Delete" aria-label="Delete" placement="top" arrow>
        <Delete onClick={() => deleteConfirmation(props.id)} style={{ color: "#646c9a", cursor: "pointer", marginLeft: 10, marginTop: 24 }} />
      </Tooltip>
    );
  }

  const downloadScore = (clientScoreID) => {
    dispatch(Admin.actions.fetchClientScoreFile({ clientScoreID: clientScoreID.id }));
  };

  useEffect(() => {
    if (clientScoreFile && clientScoreFile.base64Data) {
      const byteCharacters = atob(clientScoreFile.base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: clientScoreFile.contentType || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = clientScoreFile.fileName || "download";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      // Clear the file from the store after downloading
      dispatch(Admin.actions.clearClientScoreFile());
    }
  }, [clientScoreFile, dispatch]);

  function DownloadScoreDisplay(id) {
    return (
      <Tooltip title="Download" aria-label="Download" placement="top" arrow>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            downloadScore(id);
          }}
        >
          <CloudDownloadIcon fontSize="small" style={{ color: "#646c9a", cursor: "pointer", marginLeft: 10, marginTop: 24 }} />
        </IconButton>
      </Tooltip>
    );
  }

  function EditScoreDisplay(props) {
    return (
      <Tooltip title="Edit" aria-label="Edit" placement="top" arrow>
        <Edit onClick={() => EditScore(props.id)} style={{ color: "#646c9a", cursor: "pointer", marginLeft: 10, marginTop: 24 }} />
      </Tooltip>
    );
  }

  function EditScore(id) {
    // This displays a modal allowing the editing of a score (except file)
    setUpdateScoreId(id);
    setUpdateScoreType(clientScores.find((item) => item.id === id).scoreType);
    setUpdateScore(clientScores.find((item) => item.id === id).score);
    setUpdateScoreStage(clientScores.find((item) => item.id === id).stage);
    setUpdateScoreDate(clientScores.find((item) => item.id === id).scoreDate);
    setShowEditModal(true);
  }

  function EditScoreAction() {
    // This dispatches the update score action after some validation
    // Add some validation
    let error = false;
    if (updateScore.length === 0) {
      setUpdateScoreHelpText("You haven't typed anything!");
      error = true;
    } else if (isNaN(updateScore)) {
      setUpdateScoreHelpText("Score must be a number.");
      error = true;
    } else {
      const scoreValue = Number(updateScore);
      const range = SCORE_RANGES[updateScoreType];
      if (!range) {
        setUpdateScoreHelpText("Invalid score type.");
        error = true;
      } else if (scoreValue < range.min || scoreValue > range.max) {
        setUpdateScoreHelpText(`${updateScoreType} score must be between ${range.min} and ${range.max}.`);
        error = true;
      } else {
        setUpdateScoreHelpText("");
      }
    }

    // Check no errors
    if (!error) {
      // Build payload
      var payload = {
        scoreID: updateScoreId,
        clientID: props.clientID,
        scoreDate: updateScoreDate,
        score: updateScore,
        scoreType: updateScoreType,
        stage: updateScoreStage,
      };
      // Ok Time to Dispatch
      dispatch(Admin.actions.putClientScore(payload));
      setShowEditModal(false);
      setUpdateScoreHelpText("");
    }
  }

  function DeleteScore() {
    // Soft delete score
    dispatch(Admin.actions.deleteClientScore({ id: deleteScoreId, clientID: props.clientID }));
    setShowConfirmation(false);
  }

  function deleteConfirmation(delId) {
    setDeleteScoreId(delId);
    setDeleteScoreType(clientScores.find((item) => item.id === delId).scoreType);
    setDeleteScore(clientScores.find((item) => item.id === delId).score);
    setDeleteScoreStage(clientScores.find((item) => item.id === delId).stage);
    setDeleteScoreDate(clientScores.find((item) => item.id === delId).scoreDate);

    setShowConfirmation(true);
  }

  function handleConfirmationClose() {
    setShowConfirmation(false);
  }

  function handleEditClose() {
    setShowEditModal(false);
    setUpdateScoreHelpText("");
  }

  function addScore() {
    // Add some validation
    let error = false;
    if (newScore.length === 0) {
      setNewScoreHelpText("You haven't typed anything!");
      error = true;
    } else if (isNaN(newScore)) {
      setNewScoreHelpText("Score must be a number.");
      error = true;
    } else {
      const scoreValue = Number(newScore);
      const range = SCORE_RANGES[newScoreType];
      if (!range) {
        setNewScoreHelpText("Invalid score type.");
        error = true;
      } else if (scoreValue < range.min || scoreValue > range.max) {
        setNewScoreHelpText(`${newScoreType} score must be between ${range.min} and ${range.max}.`);
        error = true;
      } else {
        setNewScoreHelpText("");
      }
    }

    // Check no errors
    if (!error) {
      // Ok time to go - move from useState to FormData
      const formData = new FormData();
      formData.append("clientID", props.clientID);
      formData.append("scoreDate", newScoreDate);
      formData.append("score", newScore);
      formData.append("scoreType", newScoreType);
      formData.append("scoreStage", newScoreStage);
      if (newAssessmentFile) {
        formData.append("assessmentFile", newAssessmentFile);
      }
      //
      // Ok Time to Dispatch
      dispatch(Admin.actions.postClientScore({ formData: formData, clientID: props.clientID }));
      clearScore();
    }
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item md={4}>
          <Row>
            <Col md="12" style={{ marginBottom: 40 }}>
              <h5>Add New Score</h5>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Score Type</Form.Label>
                <Form.Control as="select" value={newScoreType} onChange={(event) => setNewScoreType(event.target.value)} style={{ borderColor: "#D1D1D1" }}>
                  <option value="K5">K5</option>
                  <option value="K10">K10</option>
                  <option value="IAR">IAR</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Score</Form.Label>
                <Form.Control type="text" name="newScore" value={newScore} onChange={(event) => setNewScore(event.target.value)} autoComplete="new-password" />
                {newScoreHelpText.length ? <p className="error-help">{newScoreHelpText}</p> : ""}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Stage</Form.Label>
                <Form.Control
                  as="select"
                  value={newScoreStage}
                  onChange={(event) => setNewScoreStage(event.target.value)}
                  style={{ borderColor: "#D1D1D1", padding: "0.65rem 1.5rem 0.65rem 0.5rem" }}
                >
                  <option value="Initial Assessment">Initial Assessment</option>
                  <option value="Closure Assessment">Closure Assessment</option>
                  <option value="Progress Assessment">Progress Assessment</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Date</Form.Label>
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <Form.Control
                    type="date"
                    id="newScoreDate"
                    name="newScoreDate"
                    value={newScoreDate || ""}
                    onChange={(e) => setNewScoreDate(e.target.value)}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12" style={{ marginTop: 20 }}>
              <Form.Group>
                <Form.Label>Upload Assessment (optional):</Form.Label>
                <Form.Control
                  type="file"
                  name="newAssessmentFile"
                  key={fileInputKey}
                  onChange={(event) => handleFileFieldChange("newAssessmentFile", event)}
                  className="form-control"
                  style={{ paddingTop: 6, paddingLeft: 6 }}
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />
          <Row>
            <Col md="12" style={{ marginTop: 20 }}>
              <Grid container spacing={0} padding={6} justifyContent="space-between">
                <Button variant="light" size="sm" onClick={() => clearScore()} style={{ borderColor: "#D1D1D1" }}>
                  Clear
                </Button>
                <Button variant="success" size="sm" onClick={() => addScore()}>
                  Add Score
                </Button>
              </Grid>
            </Col>
          </Row>
        </Grid>
        <Grid item md={8}>
          <Form.Group>
            <Form.Label>Scores</Form.Label>
            <TableContainer style={{ backgroundColor: "#FFF", height: 540, width: "100%", overflowY: "scroll" }}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: 120 }}>Date</TableCell>
                    <TableCell style={{ width: 160 }}>Stage</TableCell>
                    <TableCell style={{ width: 60 }}>Type</TableCell>
                    <TableCell style={{ width: 60 }}>Score</TableCell>
                    <TableCell style={{ width: 120 }}>Entered By</TableCell>
                    <TableCell style={{ width: 100 }}>Created</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clientScores
                    ? clientScores.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.scoreDate}</TableCell>
                          <TableCell>{row.stage}</TableCell>
                          <TableCell>{row.scoreType}</TableCell>
                          <TableCell>{row.score}</TableCell>
                          <TableCell>{row.createdByFullName}</TableCell>
                          <TableCell>{row.createdOn}</TableCell>
                          {row.hasFile && <DownloadScoreDisplay id={row.id} />}
                          <DeleteScoreDisplay id={row.id} />
                          {role == "Admin" && <EditScoreDisplay id={row.id} />}
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Form.Group>
        </Grid>
      </Grid>

      <Modal show={showConfirmation} onHide={handleConfirmationClose} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Delete Score Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          <Grid item md={12}>
            <Row>
              <Col md="6">
                <Form.Group style={{ width: "100%" }}>
                  <Form.Label>Score Type</Form.Label>
                  <Form.Control as="select" defaultValue={deleteScoreType} disabled>
                    <option value="K10">K10</option>
                    <option value="IAR">IAR</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Score</Form.Label>
                  <Form.Control type="text" name="deleteScore" defaultValue={deleteScore} disabled />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <Form.Group style={{ width: "100%" }}>
                  <Form.Label>Stage</Form.Label>
                  <Form.Control as="select" value={deleteScoreStage} disabled style={{ borderColor: "#D1D1D1", padding: "0.65rem 1.5rem 0.65rem 0.5rem" }}>
                    <option value="Initial Assessment">Initial Assessment</option>
                    <option value="Closure Assessment">Closure Assessment</option>
                    <option value="Progress Assessment">Progress Assessment</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group style={{ width: "100%" }}>
                  <Form.Label>Date</Form.Label>
                  <div style={{ display: "flex", alignItems: "flex-end" }}>
                    <Form.Control type="date" id="deleteScoreDate" name="deleteScoreDate" value={deleteScoreDate || ""} />
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="edit-md-modal">
          <Button variant="secondary" onClick={handleConfirmationClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={() => DeleteScore()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Edit Score</Modal.Title>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          <Row>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Score Type</Form.Label>
                <Form.Control
                  as="select"
                  value={updateScoreType}
                  onChange={(event) => setUpdateScoreType(event.target.value)}
                  style={{ borderColor: "#D1D1D1" }}
                >
                  <option value="K5">K5</option>
                  <option value="K10">K10</option>
                  <option value="IAR">IAR</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Score</Form.Label>
                <Form.Control
                  type="text"
                  name="updateScore"
                  value={updateScore}
                  onChange={(event) => setUpdateScore(event.target.value)}
                  autoComplete="new-password"
                />
                {updateScoreHelpText.length ? <p className="error-help">{updateScoreHelpText}</p> : ""}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Stage</Form.Label>
                <Form.Control
                  as="select"
                  value={updateScoreStage}
                  onChange={(event) => setUpdateScoreStage(event.target.value)}
                  style={{ borderColor: "#D1D1D1", padding: "0.65rem 1.5rem 0.65rem 0.5rem" }}
                >
                  <option value="Initial Assessment">Initial Assessment</option>
                  <option value="Closure Assessment">Closure Assessment</option>
                  <option value="Progress Assessment">Progress Assessment</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>Date</Form.Label>
                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <Form.Control
                    type="date"
                    id="updateScoreDate"
                    name="updateScoreDate"
                    value={updateScoreDate || ""}
                    onChange={(e) => setUpdateScoreDate(e.target.value)}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="edit-md-modal">
          <Button variant="secondary" onClick={handleEditClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={() => EditScoreAction()}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
